var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.835 7.837h16.339M15.072 11.091h.009M11.004 11.091h.009M6.928 11.091h.009M15.072 14.33h.009M11.004 14.33h.009M6.928 14.33h.009M14.707 1.667v2.742M7.302 1.667v2.742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.885 2.983H7.123c-2.692 0-4.373 1.364-4.373 3.87v7.541c0 2.545 1.681 3.94 4.373 3.94h7.754c2.7 0 4.373-1.371 4.373-3.877V6.853c.009-2.506-1.665-3.87-4.365-3.87",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.bc70cc47af1269df74e0b07f5a3e1491.svg";
export { ForwardRef as ReactComponent };